import {Position, Rectangle} from './math'
import jsPDF from 'jspdf'
import printJS from 'print-js-updated'
import { computeScaleAdaptedToFrame } from "./media"
import Konva from "konva"

export const PRINT_EVENT = 'PRINT_EVENT'

const DPI = 300
const CM_PER_INCH = 2.54
const A4_WIDTH = 21
const A4_HEIGHT = 29.7
const TOP_MARGIN = 2
const BOTTOM_MARGIN = 3
const LEFT_MARGIN = 1
const RIGHT_MARGIN = 1
export const A4_RATIO = A4_WIDTH / A4_HEIGHT


export const convertCmToPixels = (cm) => {
    return cm / CM_PER_INCH * DPI * window.devicePixelRatio
}

export const A4Sheet = () => ({
    frame: new Rectangle(
        convertCmToPixels(A4_WIDTH),
        convertCmToPixels(A4_HEIGHT),
    ),
    margin: {
        top: convertCmToPixels(TOP_MARGIN),
        bottom: convertCmToPixels(BOTTOM_MARGIN),
        left: convertCmToPixels(LEFT_MARGIN),
        right: convertCmToPixels(RIGHT_MARGIN),
    }
})

const createImage = (image, imageProps, pageWidth, pageHeight) => {
    const stage = new Konva.Stage({
        width: convertCmToPixels(pageWidth),
        height: convertCmToPixels(pageHeight),
        container: document.createElement('div'),
    })
    const layer = new Konva.Layer()
    stage.add(layer)

    const scale = computeScaleAdaptedToFrame({ width: stage.width(), height: stage.height() }, image) * imageProps.filters.scale
    const scaledImageRect = (new Rectangle(imageProps.width, imageProps.height, imageProps.position)).scale(scale)
    const stageRect = new Rectangle(stage.width(), stage.height())
    const stageRectRotationFilterApplied = stageRect.rotate(imageProps.filters.rotate)

    const imagePosition = new Position(
        Math.round(stageRect.width / 2),
        Math.round(stageRect.height / 2)
    )
    const imageOffset = new Position(
        (scaledImageRect.width / 2 - scaledImageRect.position.x),
        (scaledImageRect.height / 2 - scaledImageRect.position.y),
    )

    const filters = [Konva.Filters.Brighten, Konva.Filters.Contrast]
    if(imageProps.isInvertActive)
    {
        filters.push(Konva.Filters.Invert)
    }

    const cacheRect = new Rectangle(stage.width(), stage.height()).rotate(-imageProps.filters.rotate)
    let cachePosition = new Position(
        Math.round(stageRectRotationFilterApplied.width / 2),
        Math.round(stageRectRotationFilterApplied.height / 2)
    )
    cachePosition = imageOffset.move(cachePosition.convertToVector().invert())

    layer.add(new Konva.Image({
        offsetX: imageOffset.x,
        offsetY: imageOffset.y,
        x: imagePosition.x,
        y: imagePosition.y,
        image,
        width: scaledImageRect.width,
        height: scaledImageRect.height,
        rotation: imageProps.filters.rotate,
        filters,
        brightness: imageProps.filters.brightness,
        contrast: imageProps.filters.contrast,
    }).cache({
        width: cacheRect.width,
        height: cacheRect.height,
        x: cachePosition.x,
        y: cachePosition.y,
    }))

    return stage
}

export const initPrintListener = () => {
    document.addEventListener(PRINT_EVENT, function (event) {
        const doc = new jsPDF({
            orientation: event.detail.orientation,
            unit: 'cm',
            format: 'a4'
        })

        const image = new Image()
        image.crossOrigin='anonymous'
        image.addEventListener("load", () => {
            const pageHeight = doc.internal.pageSize.getHeight() - TOP_MARGIN - BOTTOM_MARGIN
            const pageWidth = doc.internal.pageSize.getWidth() - LEFT_MARGIN - RIGHT_MARGIN

            doc.setFontSize(11)
            doc.setFont('Courier')
            doc.text(event.detail.title, LEFT_MARGIN, TOP_MARGIN / 2, { baseline: 'top' })

            doc.addImage(
                createImage(image, event.detail, pageWidth, pageHeight).toDataURL(),
                'JPEG',
                LEFT_MARGIN,
                TOP_MARGIN,
                pageWidth,
                pageHeight,
                null,
                'NONE'
            )

            printJS(doc.output('bloburl'))
        })

        image.src = event.detail.location
    })
}
